<!--
 * @Author: dengjianwen deng_jwen@163.com
 * @Date: 2023-06-27 06:03:56
 * @LastEditors: dengjianwen deng_jwen@163.com
 * @LastEditTime: 2023-07-10 08:31:00
 * @FilePath: /yingcai-culture-h5/src/views/CertificateExaminer/index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="certificate-student">
    <div class="certificate-student-title">新测评(繁)证书申请</div>
    <div class="certificate-student-form">
      <van-form @submit="onSubmit"
        ><van-field name="imageUrl" label="学员照片">
          <template #input>
            <van-uploader
              :max-count="1"
              :fileList="form.imageUrl ? [{ url: form.imageUrl || '' }] : []"
              :before-read="beforeRead"
            />
          </template>
        </van-field>
        <van-field
          v-model="form.name"
          name="name"
          label="姓名"
          placeholder="姓名"
          :rules="[{ required: true, message: '请填写姓名' }]"
        >
          <template #button>
            <van-button size="small" type="info" @click.native="fetchGetPinyin"
              >获取拼音</van-button
            >
          </template>
        </van-field>
        <van-field
          v-model="form.namePy"
          name="namePy"
          label="姓名(拼音)"
          placeholder="姓名(拼音)"
          :rules="[{ required: true, message: '请填写姓名(拼音)' }]"
        />
        <van-field
          readonly
          clickable
          name="sex"
          :value="form.sex"
          label="性别"
          placeholder="点击选择性别"
          @click="showSexPicker = true"
          :rules="[{ required: true, message: '请选择性别' }]"
        />
        <van-field
          readonly
          clickable
          name="nationality"
          :value="form.nationality"
          label="国籍"
          placeholder="点击选择国籍"
          @click="showNationalityPicker = true"
          :rules="[{ required: true, message: '请选择国籍' }]"
        />
        <van-field
          readonly
          clickable
          name="object"
          :value="form.subject"
          label="专业"
          placeholder="点击选择专业"
          @click="showObjectPicker = true"
          :rules="[{ required: true, message: '请选择专业' }]"
        />
        <van-field
          readonly
          clickable
          name="level"
          :value="form.level"
          label="级别"
          placeholder="点击选择级别"
          @click="showLevelPicker = true"
          :rules="[{ required: true, message: '请选择级别' }]"
        />
        <div style="margin: 16px">
          <van-button round block type="info" native-type="submit"
            >提交</van-button
          >
        </div>
      </van-form>
    </div>
    <van-popup v-model="show"
      ><img :src="imageUrl" style="width: 350px"
    /></van-popup>
    <van-popup v-model="showSexPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="['男', '女']"
        @confirm="(value) => onConfirm(value, 'sex')"
        @cancel="showSexPicker = false"
      />
    </van-popup>
    <van-popup v-model="showNationalityPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="nationalityList.map((item) => item.name)"
        @confirm="(value) => onConfirm(value, 'nationality')"
        @cancel="showNationalityPicker = false"
      />
    </van-popup>
    <van-popup v-model="showObjectPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="objectList.map((item) => item.name)"
        @confirm="(value) => onConfirm(value, 'subject')"
        @cancel="showObjectPicker = false"
      />
    </van-popup>
    <van-popup v-model="showLevelPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="levelList.map((item) => item.name)"
        @confirm="(value) => onConfirm(value, 'level')"
        @cancel="showLevelPicker = false"
      />
    </van-popup>
  </div>
</template>
<script>
import { Toast } from "vant";
import {
  checkCertificateNo,
  getObjectIdList,
  getNationalityList,
  getLevelList,
  uploadFile,
  createCertificateStudentApplication,
  getPinyin,
} from "../../api/home";
export default {
  name: "CertificateStudent",
  data() {
    return {
      certificateNo: "",
      show: false,
      imageUrl: "",
      form: {
        name: "",
        namePy: "",
        sex: "",
        nationality: "",
        subject: "",
        level: "",
        imageUrl: "",
      },
      showSexPicker: false,
      showLevelPicker: false,
      showObjectPicker: false,
      showNationalityPicker: false,
      levelList: [],
      objectList: [],
      nationalityList: [],
    };
  },
  mounted() {
    this.fetchGetLevelList();
    this.fetchGetNationalityList();
    this.fetchGetObjectList();
  },
  methods: {
    async fetchCheckCertificateNo() {
      if (this.certificateNo === "") {
        Toast("请输入证书编码");
        return;
      }
      const result = await checkCertificateNo({
        certificateNo: this.certificateNo,
        memberType: "3",
      });
      if (result.code === "0" && result.data === "1") {
        this.show = true;
        this.imageUrl = `https://ys-culture.top/api/certificateExaminer/card?no=${this.certificateNo}`;
      }
    },
    async fetchGetPinyin() {
      if (this.form.name === "") {
        Toast("请输入姓名");
        return;
      }
      const result = await getPinyin({
        china: this.form.name,
      });
      if (result.code === "0") {
        this.form.namePy = result.data;
      }
    },
    async beforeRead(file) {
      if (file.type !== "image/jpeg" && file.type !== "image/jpg") {
        Toast("请上传 jpg 格式图片");
        return false;
      }
      console.log(file);
      const result = await uploadFile(file);
      if (result.code === "0") {
        this.form.imageUrl = result.data.url;
        Toast("上传成功");
      }
      return false;
    },
    async onSubmit(values) {
      console.log("submit", values);
      const result = await createCertificateStudentApplication({
        ...values,
        imageUrl: this.form.imageUrl,
        sex: this.form.sex === "男" ? "1" : "2",
        nationality: this.nationalityList.find(
          (item) => item.name === this.form.nationality
        ).id,
        subject: this.objectList.find((item) => item.name === this.form.subject)
          .id,
        level: this.levelList.find((item) => item.name === this.form.level).id,
        accountId: this.$route.params.id,
      });
      if (result.code === "0") {
        this.form = {
          name: "",
          namePy: "",
          sex: "",
          sexPy: "",
          nationality: "",
          subject: "",
          level: "",
          imageUrl: "",
        };
        Toast("提交成功");
      } else {
        Toast("提交失败");
      }
    },

    async fetchGetObjectList() {
      const result = await getObjectIdList();
      if (result.code === "0") {
        this.objectList = result.data;
      } else {
        Toast(result.msg);
      }
    },
    async fetchGetNationalityList() {
      const result = await getNationalityList();
      if (result.code === "0") {
        this.nationalityList = result.data;
      } else {
        Toast(result.msg);
      }
    },
    async fetchGetLevelList() {
      const result = await getLevelList();
      if (result.code === "0") {
        this.levelList = result.data;
      } else {
        Toast(result.msg);
      }
    },
    onConfirm(value, key) {
      this.form[key] = value;
      this.showSexPicker = false;
      this.showNationalityPicker = false;
      this.showObjectPicker = false;
      this.showLevelPicker = false;
    },
  },
};
</script>

<style lang="less" scoped>
.certificate-student {
  padding: 0 8px;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.certificate-student-title {
  margin-top: 24px;
  font-size: 28px;
  font-weight: 500;
  color: #333;
}
.certificate-student-img {
  padding-top: 48px;
  width: 240px;
}
.certificate-student-form {
  padding: 24px 0;
  width: 98%;
}
</style>
